module.exports = __webpack_public_path__ + "static/media/logotype-final-light-theme.909ea881.svg";